import React, { Component } from 'react';

class HowItWork extends Component {
    render() {
        return (
            <section className="how__work">
				<div className="container-fluid">
					<h1 className="how__work--heading">How it works.</h1>
					<div className="row">
						<div className="col-md-4">	
							<div className="how__work--steps">	
								<span>Step 1</span>
								<h4>Skin Assessment</h4>
								<p>to help us understand your skin needs</p>
							</div>
						</div>
						<div className="col-md-4">	
							<div className="how__work--steps">	
								<span>Step 2</span>
								<h4>See Your personalised routine</h4>
								<p>With details of ingredients in your skincare</p>
							</div>
						</div>
						<div className="col-md-4">	
							<div className="how__work--steps">	
								<span>Step 3</span>
								<h4>Try Yours</h4>
								<p>to help us understand your skin needs</p>
							</div>
						</div>
					</div>
				</div>
			</section>
        );
    }
}


export default HowItWork;